import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Header, Icon, Input } from "semantic-ui-react";
import { Button,Grid, Form } from 'semantic-ui-react'
import { useDispatch } from "react-redux";
import { setDatabase} from "../../features/tableData/visualSlice";


function Login({callback}) {
  // useState hooks to manage form state
  const [securityKey, setSecurityKey] = useState("");
  const dispatch = useDispatch();
  const [loginInProgress, setLoginInProgress] = useState(false);
  const handleChange = (e) => {
    setSecurityKey(e.target.value);
  };


  const navigate = useNavigate();

  const handleSubmit = async event => {
    setLoginInProgress(true);
    event.preventDefault();
    const response = axios.get(`${process.env.REACT_APP_BACKEND_URL}/login?securityKey=${securityKey}`);
    response.then((response) => {
            console.log(response.data);
            setLoginInProgress(false);
            callback(securityKey);
            navigate('/Home');
            dispatch(setDatabase(response.data));
        },
        (error) => {
            setLoginInProgress(false);
            alert("Wrong security key, please check");
            console.log(error);
        }
    )
  }
  const handleWaitlist = event => {
    window.location.href= "https://tally.so/r/woE2D5";
  }

  return (
    <Grid>
      <Grid.Row>
        <div style={{height: "30vh"}}> </div>
      </Grid.Row>
      <Grid.Row columns={3}>
        <Grid.Column width={4}></Grid.Column>
        <Grid.Column width={8} className='login'>
          <Grid>
            <Grid.Row columns={3}>
              <Grid.Column width={5}></Grid.Column>
              <Grid.Column width={7}>
              <Header as="h3">Welcome to Baselit Playground!</Header>
              </Grid.Column>
              <Grid.Column width={5}></Grid.Column>
            </Grid.Row>
            <Grid.Row columns={1}>  
              <Grid.Column width={16}>
              <Form>
                <Form.Field>
                  {/* <label>Login key</label> */}
                  <Input fluid onChange={handleChange} value={securityKey} placeholder="Enter Login key here..."/>
                </Form.Field>
                <Button type='submit' onClick={handleSubmit}>Enter</Button>
                {loginInProgress && <Icon name='spinner' loading/>}
                <Form.Field></Form.Field>
                <Form.Field>
                  <label>Don't have a Login key? Join our waitlist to get one!</label>
                </Form.Field>
                <Button onClick={handleWaitlist}>Join Waitlist</Button>
              </Form>
              </Grid.Column>
          </Grid.Row>
          </Grid>
        </Grid.Column>
        <Grid.Column width={4}></Grid.Column>
      </Grid.Row>
    </Grid>
  );
}


export default Login;
